module.exports = __webpack_public_path__ + "static/media/porcobrar_black.25af7afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/porcobrar_black.png
// module id = 604
// module chunks = 16